<div *ngIf="tinySettings; else full" class="validity tiny">
  <atm-validity-status
    [validity]="validity"
    [validityTz]="validityTz"
  ></atm-validity-status>
</div>
<ng-template #full>
  <div class="validity" [class.withActions]="actions">
    <div class="date-holder">
      <h3 *ngIf="!tinySettings">
        {{ validityData.timezone?.value || "Start date - UTC" }}
      </h3>
      <div>
        {{ validityData.start?.date | date : "dd MMM YYYY" }} -
        {{ validityData.start?.date | date : "HH:mm" }}
      </div>
    </div>
    <atm-validity-status
      [validity]="validity"
      [validityTz]="validityTz"
    ></atm-validity-status>
    <div class="date-holder">
      <h3 *ngIf="!tinySettings">End date :</h3>
      <div>
        {{ validityData.end?.date | date : "dd MMM YYYY" }} -
        {{ validityData.end?.date | date : "HH:mm" }}
      </div>
    </div>
  </div>
  <div class="actions" *ngIf="actions && fullSettings">
    <button mat-flat-button type="button" (click)="setValidity()">
      {{ !isUpdate ? "Define a time validity" : "Modify time validity" }}
    </button>
  </div>
</ng-template>
